module.exports = __webpack_public_path__ + "img/arrow.175ccbf9.svg";